/**
 * TruEats Sliders JS
 * Swiper initialization for product slider, ingredients sliders, retailers carousel.
 * Requires Swiper to be loaded globally before this script runs.
 * File: assets/trueats-sliders.js  |  Status: NEW
 */
(function () {
  'use strict';

  /* ── Helpers (defined first so the public API can reference them) ────────── */
  function makeIngredientSwiper(el, nextSel, prevSel) {
    if (!el || el.swiper) return;
    new Swiper(el, {
      slidesPerView: 1, /* explicit — prevents Swiper using a wrong default path */
      spaceBetween: 0,
      loop: false,
      navigation: { nextEl: nextSel, prevEl: prevSel },
    });
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        if (el.swiper) el.swiper.update();
      });
    });
  }

  /* ── Public API — defined before any guard so it is ALWAYS available ─────── */
  window.TruEatsSliders = window.TruEatsSliders || {};
  window.TruEatsSliders.activateIngredientPanel = function (panelEl) {
    if (!panelEl || typeof Swiper === 'undefined') return;
    var swiperEl = panelEl.querySelector('.swiper');
    if (!swiperEl) return;
    if (swiperEl.swiper) {
      swiperEl.swiper.update();
    } else {
      var id = swiperEl.id;
      if (id === 'trueats-ingredients-slider-1') {
        makeIngredientSwiper(swiperEl, '.trueats-ingredients__nav--next-1', '.trueats-ingredients__nav--prev-1');
      } else if (id === 'trueats-ingredients-slider-2') {
        makeIngredientSwiper(swiperEl, '.trueats-ingredients__nav--next-2', '.trueats-ingredients__nav--prev-2');
      }
    }
  };

  /* ── Retry if Swiper is not yet loaded (CDN defer timing) ────────────────── */
  if (typeof Swiper === 'undefined') {
    window.addEventListener('load', function () {
      if (typeof Swiper === 'undefined') {
        console.warn('TruEats: Swiper not found. Make sure it is loaded before trueats-sliders.js');
        return;
      }
      initAll();
    });
    return;
  }

  /* ── Slider init functions ───────────────────────────────────────────────── */
  function initAll() {
    initProductsSlider();
    initIngredientsSliders();
    initRetailersSlider();
  }

  /* ── Black Label Product Slider ────────────────────────────────────────── */
  function initProductsSlider() {
    var el = document.getElementById('trueats-products-slider');
    if (!el) return;

    new Swiper(el, {
      slidesPerView: 1,
      spaceBetween: 20,
      loop: true,
      navigation: {
        nextEl: '.trueats-product-slider__nav--next',
        prevEl: '.trueats-product-slider__nav--prev',
      },
      breakpoints: {
        640:  { slidesPerView: 2, spaceBetween: 20 },
        1024: { slidesPerView: 3, spaceBetween: 30 },
        1440: { slidesPerView: 4, spaceBetween: 40 },
      },
    });
  }

  /* ── Ingredients Sliders (two independent instances) ───────────────────── */
  function initIngredientsSliders() {
    var panel1 = document.getElementById('trueats-ingredients-slider-1');
    if (panel1) {
      var wrap1 = panel1.closest('[data-trueats-ingredient-panel]');
      /* Only init if the parent panel is currently visible */
      if (!wrap1 || getComputedStyle(wrap1).display !== 'none') {
        makeIngredientSwiper(panel1, '.trueats-ingredients__nav--next-1', '.trueats-ingredients__nav--prev-1');
      }
    }

    var panel2 = document.getElementById('trueats-ingredients-slider-2');
    if (panel2) {
      var wrap2 = panel2.closest('[data-trueats-ingredient-panel]');
      if (!wrap2 || getComputedStyle(wrap2).display !== 'none') {
        makeIngredientSwiper(panel2, '.trueats-ingredients__nav--next-2', '.trueats-ingredients__nav--prev-2');
      }
    }
  }

  /* ── Retailers Carousel ────────────────────────────────────────────────── */
  function initRetailersSlider() {
    var el = document.getElementById('trueats-retailers-slider');
    if (!el) return;

    new Swiper(el, {
      slidesPerView: 2,
      spaceBetween: 12,
      loop: true,
      navigation: {
        nextEl: '.trueats-retailers__nav--next',
        prevEl: '.trueats-retailers__nav--prev',
      },
      breakpoints: {
        480:  { slidesPerView: 3, spaceBetween: 12 },
        640:  { slidesPerView: 4, spaceBetween: 16 },
        1024: { slidesPerView: 5, spaceBetween: 20 },
        1440: { slidesPerView: 8, spaceBetween: 24 },
      },
    });
  }

  /* ── Boot — run after all deferred scripts (including Swiper CDN) ─────── */
  if (document.readyState === 'complete') {
    initAll();
  } else {
    window.addEventListener('load', initAll);
  }
})();
